<template>
  <div>
    <el-input :disabled="disabled" v-model="c_value" @change="changeEightBigCode">
      <i slot="suffix" style="cursor: pointer;" class="el-input__icon el-icon-search" @click="prePick" v-if="!((disabled&&mark==='1')||(disabled&&mark==='2'))"></i>
    </el-input>
    <el-dialog width="1200px" :visible="showDialog" :append-to-body="true" @close="showDialog =false">
      <MaterialPickPage :isLto="isLto" :tmSupplierId="id" :mark="mark" @subCallMethod="pickMaterial"></MaterialPickPage>
    </el-dialog>
  </div>
</template>

<script>
import MaterialSelectPage from "@/components/page/base-data/material-sel-page";
import dataTableUtils from "@/utils/dataTableUtils";
import MaterialPickPage from "@/components/page/base-data/material-pick-page";
import commonMethods from "@/utils/commonMethods";
export default {
  name: "materialInput",
  components: { MaterialPickPage },
  extends: commonMethods,
  props: {
    value: {
      type: String,
    },
    disabled: {
      type: Boolean,
    },
    isLto: {
      type: String,
    },
    tmSupplierId: {
      type: String,
    },
    canPick: {
      type: Boolean,
      default: true
    },
    onPick: {
      type: Function,
    },
    mark: {
      type: String,
    }
  },
  watch: {
    value: {
      handler(newVal, oldVal) {
        this.c_value = newVal;
      },
      immediate: true,
    },
    mark: {
      handler(newVal, oldVal) {
        console.log("🚀 ~ file: materialInput.vue:54 ~ handler ~ newVal:", newVal)
      },
      immediate: true,
    },
  },
  data() {
    return {
      c_value: this.value,
      isLto: this.isLto,
      id: this.tmSupplierId,
      material: null,
      showDialog: false
    }
  },
  create() {
  },
  methods: {
    prePick() {
      if (this.canPick) {
        this.showDialog = true;
      }
    },
    pickMaterial(material) {
      this.material = material;
      this.c_value = material.eightBitCode;
      this.$emit("input", material.eightBitCode);
      this.$emit("pick", material);
      this.dispatchFormValide(material.eightBitCode);
      this.showDialog = false;
    },
    changeEightBigCode() {

      this.material = { eightBitCode: this.c_value };
      this.$emit("input", this.material.eightBitCode);
      this.$emit("pick", this.material);
    }
  }
}
</script>

<style scoped>
input {
  border-color: rgb(220 223 230);
}
</style>
